import {removeDiacritics} from "../helpers/stringHelpers";
import {playBeep, wait} from "@/components/cyphers/helpers/sound";

const Morse = {
    cyp: {
        a: '.-',
        b: '-...',
        c: '-.-.',
        d: '-..',
        e: '.',
        f: '..-.',
        g: '--.',
        h: '....',
        '*': '----',
        i: '..',
        j: '.---',
        k: '-.-',
        l: '.-..',
        m: '--',
        n: '-.',
        o: '---',
        p: '.--.',
        q: '--.-',
        r: '.-.',
        s: '...',
        t: '-',
        u: '..-',
        v: '...-',
        w: '.--',
        x: '-..-',
        y: '-.--',
        z: '--..',
        0: '-----',
        1: '.----',
        2: '..---',
        3: '...--',
        4: '....-',
        5: '.....',
        6: '-....',
        7: '--...',
        8: '---..',
        9: '----.',
        '.': '/',
        '!': '/',
        '?': '/',
        ' ': ''
    },
    dec: {
        '.-': 'a',
        '-...': 'b',
        '-.-.': 'c',
        '-..': 'd',
        '.': 'e',
        '..-.': 'f',
        '--.': 'g',
        '....': 'h',
        '----': 'ch',
        '..': 'i',
        '.---': 'j',
        '-.-': 'k',
        '.-..': 'l',
        '--': 'm',
        '-.': 'n',
        '---': 'o',
        '.--.': 'p',
        '--.-': 'q',
        '.-.': 'r',
        '...': 's',
        '-': 't',
        '..-': 'u',
        '...-': 'v',
        '.--': 'w',
        '-..-': 'x',
        '-.--': 'y',
        '--..': 'z',
        '-----': '0',
        '.----': '1',
        '..---': '2',
        '...--': '3',
        '....-': '4',
        '.....': '5',
        '-....': '6',
        '--...': '7',
        '---..': '8',
        '----.': '9',
        '': ' '
    }
}
export const defaultDotDuration = 233;
let stopBeepingBool = false;
let beeping = false;
const SEPARATOR = '/'
export const methods = {
    cypher: function (input, hasCh = false, missing = null, params, sep = SEPARATOR) {
        let string = []
        let cleaned = removeDiacritics(input).toLowerCase()
            .replace("ch", '*')
            .replace("  ", ' ')
            .replace(", ", '')
            .replace(",", '')
            .replace("..", '.')
            .replace(". ", '.')
            .replace(" . ", '.')
            .replace(".  ", '.')
        cleaned.split('').forEach((char) => {
            string.push(Morse.cyp[char]);
        })
        return string.join(sep);
    },
    decypher: function (input, hasCh = false, missing = null, params, sep = SEPARATOR) {
        let string = []
        input.split(sep).forEach((char) => {
            string.push(Morse.dec[char.trim()]);
        })
        return string.join('').replace('  ', '. ');
    },
    beepIt: async function (cyphered, dotDuration = 233, stopCallback) {
        if(beeping){
            await wait(4*dotDuration);
            methods.stopBeeping();
            return
        }
        beeping = true;
        let characters = cyphered.split("/");
        // console.log(characters)
        for (let character of characters) {
            let chars = character.split("")
            // console.log(chars)
            for (let char of chars) {
                if(stopBeepingBool){
                    stopBeepingBool=false;
                    if(typeof(stopCallback) === 'function'){
                        stopCallback();
                    }
                    beeping = false;
                    return
                }
                switch (char) {
                    case '.':
                        await playBeep(dotDuration);
                        break;
                    case '-':
                        await playBeep(3 * dotDuration);
                        break;
                    default:
                        break;
                }
                await wait(2*dotDuration);// pauza mezi znaky ma byt delka jedne tecky
            }
            await wait(3 * dotDuration);// pauza mezi písmeny
        }
        stopCallback();
    },
    stopBeeping:function () {
        if(beeping){
            stopBeepingBool = true;
            beeping = false;
        }
    },
    getDotDuration:()=>{ return defaultDotDuration;    }
};

export default {...methods,SEPARATOR}